import { useState } from 'react';
import type { DokumentyDokumentDto } from '@gov-nx/api';
import { documentsListQuery, usePoQuery, useAxiosInstance } from '@gov-nx/api';
import { MyFilesSource } from '@gov-nx/module/page';
import { useExtraConfigContext } from '@gov-nx/core/app';

export const useDocumentsModal = () => {
	const [showDocumentsModal, setShowDocumentsModal] = useState(false);
	const [documents, setDocuments] = useState<DokumentyDokumentDto[]>([]);
	const { axiosInstance } = useAxiosInstance();
	const {
		extraConfig: {
			pageRoutes: {
				databoxConfig: { isSelectAttachmentsFromOwnFilesRestrictedToPodani },
			},
		},
	} = useExtraConfigContext();

	usePoQuery({
		queryKey: ['documents-list'],
		queryFn: async () =>
			documentsListQuery(axiosInstance)({
				jeSoubor: true,
				smazano: false,
				razeni: '-datumVytvoreni',
				zdroje: isSelectAttachmentsFromOwnFilesRestrictedToPodani
					? MyFilesSource.VSTUP_NEBO_VYSTUP_PODANI
					: null,
			}),
		onSuccess: (data) => {
			setDocuments(data || []);
		},
	});

	return {
		showDocumentsModal,
		setShowDocumentsModal,
		documents: documents as DokumentyDokumentDto[],
		setDocuments,
	};
};
